import settings from "../../settings";
import axios, { AxiosInstance, AxiosResponse } from "axios";
import { NewDeal } from "../models/NewDeal";
import { NewDealReqest } from "../models/NewDealReqest";

const EpendisisApi: AxiosInstance = axios.create({
  baseURL: settings.Functions.EpendisisApi,
});

export const GetAllCampains = async (token: string): Promise<NewDeal[]> => {
  try {
    EpendisisApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    const response: AxiosResponse<NewDeal[]> = await EpendisisApi.get(
      "/api/campaign/getEmailCampaign"
    );
    return response.data;
  } catch (error: any) {
    return error?.response;
  }
};

export const SaveEmailCampaign = async (
  token: string,
  data: NewDealReqest
): Promise<any> => {
  try {
    EpendisisApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    const response: AxiosResponse<any> = await EpendisisApi.post(
      "/api/campaign/saveEmailCampaign",
      data
    );
    return response;
  } catch (error: any) {
    return error?.response;
  }
};
